import { useMemo } from 'react'
import { Trans } from '@lingui/macro'
import { Alert, Box } from '@mui/material'

import { useGetDcServiceVersionQuery } from '@/core/services/dmp-connect-js2'
import { useGetDmpConnectBuildVersionQuery } from '@/core/services/dmp-connect'
import { useOperatingSystem } from '@/hooks/useOperatingSystem'
import { skipToken } from '@reduxjs/toolkit/query'

import { DownloadButtons } from './DownloadButtons'

const SUPPORTED_OS = ['windows', 'macos'] as const

export function DmpConnectVersion() {
  const userOS = useOperatingSystem()
  const os = useMemo(() => SUPPORTED_OS.find((os) => os === userOS?.toLocaleLowerCase()), [userOS])

  const { data: serviceVersion } = useGetDcServiceVersionQuery()
  const { data: buildVersion } = useGetDmpConnectBuildVersionQuery(os ?? skipToken)

  const isNotUpToDate = buildVersion && serviceVersion && buildVersion !== serviceVersion.s_version

  if (!isNotUpToDate) return null

  return (
    <Alert severity="warning" sx={{ mb: 2, '& .MuiAlert-message': { flex: 1 } }}>
      <Trans>The connector is not up to date. Please download the latest version.</Trans>
      <Box mt={1}>
        <DownloadButtons />
      </Box>
    </Alert>
  )
}
